import { useEffect, useState } from 'react';
import { useLanguage } from '../../hooks/useLanguage';
import api from "../../services/api";

import styles from './index.module.scss';
import SkeletonAbout from '../Skeleton/SkeletonAbout';

export default function About() {
  const [loading, setLoading] = useState(true);
  const [images, setImages] = useState([]);
  const [aboutText, setAboutText] = useState([]);

  const { language } = useLanguage();

  const handleUploadAboutTextAndImage = async () => {
    const [{
      data: title
    }, {
      data: text
    }, {
      data: image
    }] = await Promise.all([
      api.get('paginas', {
        params: {
          Nome: 'Sobre',
          Tag: 'Sobre',
          IdiomaId: language
        }
      }),
      api.get('paginas', {
        params: {
          Nome: 'Fornecimento',
          Tag: 'Fornecimento',
          IdiomaId: language
        }
      }),
      api.get('sobre/obterTodos', {
        params: {
          IdiomaId: language
        }
      })
    ]);

    setImages(image.value);
    setAboutText(() => ({
      title: title.value,
      text: text.value
    }));
    setLoading(false);
  }

  useEffect(() => {
    if (!language) return;

    handleUploadAboutTextAndImage();
  }, [language]);

  return loading ? (
    <div className={styles.skeleton}>
      <SkeletonAbout />
    </div>
  ) : (
    <section className={styles.about}>
      <div className={styles.container}>
        <h1>{aboutText?.title?.titulo}</h1>

        <p>{aboutText?.title?.conteudo}</p>

        <div className={styles.container}>
          <div className={styles.row}>
            {images.map(({ imagem, titulo, url_Pt, url_En }, index) => (
              <a key={index} href={language === '1' ? url_Pt : url_En} target="_blank">
                <figure>
                  <img src={imagem} alt={titulo} />
                  <span>{titulo}</span>
                </figure>
              </a>
            ))}
          </div>
        </div>

        <p dangerouslySetInnerHTML={{ __html: aboutText?.text?.conteudo }}></p>
      </div>
    </section>
  )
}